module.exports = __webpack_public_path__ + "static/media/savings.311ec6f0.svg";